import React, { useState, useRef } from "react";
import { TableWithPagination } from "../../globalComponents/TableWithPagination";
import { ToolBar } from "../../globalComponents/ToolBar";
import { Popover, Space } from "antd";
import { StyledCard } from "../../globalComponents/styles";
import { useRouteMatch, Route, Switch, useHistory } from "react-router";
import { AddItem } from "./AddItem";
import { ItemDetails } from "./ItemDetails";
import { selectItems, fetchAllItems } from "./slice";
import { useDispatch, useSelector } from "react-redux";
import { FiMoreVertical } from "react-icons/fi";
import Services from "../../../services";
import { Feedback } from "../../globalComponents/Feedback";
import { DeleteModal } from "../../globalComponents/deleteModal";
import { EditItem } from "./EditItem";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const Items = (props) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const { itemList, paginationProps } = useSelector(selectItems);
  const [searchItem, setSearchItem] = useState({});
  const dispatcher = useDispatch();
  const fileInputRef = useRef(null);

  const [deleteModalProps, setDeleteModalProps] = useState({
    visible: false,
    name: "",
    id: null,
    loading: false,
  });

  const [feedbackProps, setFeedbackProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const columns = [
    {
      title: "Item",
      dataIndex: "itemName",
      key: "itemName",
    },
    /*  {
      title: 'Item ID',
      dataIndex: 'itemId',
      key: 'itemId',
    }, */
    {
      title: "Item Class",
      dataIndex: "itemCategory",
      key: "itemCategory",
      render: (data) => {
        return data === "1" ? "Stock Item" : "Component Item";
      },
    },
    {
      title: "Unit Price",
      dataIndex: "lastUnitCost",
      key: "lastUnitCost",
    },
    {
      title: "Unit Cost",
      dataIndex: "costPrice",
      key: "costPrice",
    },
    {
      title: "Stock on hand",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Warehouse",
      dataIndex: "wareHouseName",
      key: "wareHouseName",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "5%",
      render: (data, allData) => {
        const content = (
          <Space direction="vertical" size="small">
            <p
              style={{ cursor: "pointer" }}
              onClick={() => history.push(`${url}/${allData.id}`)}
            >
              View Detail
            </p>
            <p
              style={{ cursor: "pointer" }}
              onClick={() => history.push(`${url}/${allData.id}/edit`)}
            >
              Edit
            </p>
            <p
              onClick={() =>
                setDeleteModalProps({
                  name: allData.itemName,
                  id: allData.id,
                  visible: true,
                })
              }
              style={{ color: "red", cursor: "pointer" }}
            >
              Delete
            </p>
          </Space>
        );
        return (
          <Popover content={content} trigger="click">
            <FiMoreVertical />
          </Popover>
        );
      },
    },
  ];

  const filteredList = itemList.filter((item) => item.id === searchItem);
  const displayItemlist = filteredList.length > 0 ? filteredList : itemList;
  /* useEffect(() => {
    getAllItems();
  },[]) */

  const handleChangePage = (event, newPage) => {
    (async () => {
      setPage(newPage);
      await dispatcher(fetchAllItems({ page: newPage, size: rowsPerPage }));
    })();
  };

  const handleChangeRowsPerPage = (event) => {
    (async () => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      await dispatcher(
        fetchAllItems({ page: 0, size: parseInt(event.target.value, 10) })
      );
    })();
  };

  const gotoAddItem = () => {
    history.push(`${url}/add-item`);
  };

  const handleItemDelete = async () => {
    try {
      setDeleteModalProps((prevState) => ({ ...prevState, loading: true }));
      await Services.deleteItem({
        id: deleteModalProps.id,
      });
      await dispatcher(fetchAllItems({ page, size: rowsPerPage }));
      setFeedbackProps({
        type: "success",
        message: `${deleteModalProps.name} has been deleted`,
        open: true,
      });
      setDeleteModalProps((prevState) => ({
        ...prevState,
        loading: false,
        visible: false,
      }));
    } catch (error) {
      console.log(error);
      setDeleteModalProps((prevState) => ({ ...prevState, loading: false }));
      setFeedbackProps({
        type: "error",
        message: `Please try again`,
        open: true,
      });
    }
  };

  const handleTriggerImport = () => {
    fileInputRef.current.click();
  };

  const handleImportFile = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log("Imported data:", jsonData);

      // Send jsonData to your backend or state
    };

    reader.readAsArrayBuffer(file);
  };

  // const exportFile = () => {
  //   if (!displayItemlist || !displayItemlist.length) {
  //     return alert("No data to export.");
  //   }

  //   const headers = Object.keys(displayItemlist[0]);
  //   const csvRows = [
  //     headers.join(","), // CSV header
  //     ...displayItemlist.map((row) =>
  //       headers.map((field) => JSON.stringify(row[field] ?? "")).join(",")
  //     ),
  //   ];

  //   const csvContent = csvRows.join("\n");
  //   const blob = new Blob([csvContent], { type: "text/csv" });
  //   const url = URL.createObjectURL(blob);

  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "items_export.csv";
  //   a.click();

  //   URL.revokeObjectURL(url); // Clean up
  // };

  // const exportFile = () => {
  //   if (!displayItemlist || !displayItemlist.length) {
  //     return alert("No data to export.");
  //   }

  //   // ✅ Define fields to export and display names
  //   const fieldsToExport = [
  //     { key: "itemName", label: "Item Name" },
  //     { key: "itemCategory", label: "Item Class" },
  //     { key: "unitPrice", label: "Unit Price" },
  //     { key: "costPrice", label: "Unit Cost" },
  //     { key: "quantity", label: "Stock on Hand" },
  //     { key: "wareHouseName", label: "Warehouse" },
  //   ];

  //   // ✅ CSV header
  //   const headers = fieldsToExport.map((f) => `"${f.label.padEnd(25)}"`); // Wider header

  //   const csvRows = [
  //     headers.join(","), // Header row
  //     ...displayItemlist.map((row) =>
  //       fieldsToExport
  //         .map((f) => {
  //           let value = row[f.key] ?? ""; // Handle undefined/null

  //           if (typeof value === "number") {
  //             value = value.toString().padEnd(25); // Numeric padding
  //           } else if (typeof value === "string") {
  //             value = ` ${value.padEnd(24)} `; // String padding (24 + 1 left + 1 right = 26)
  //           }

  //           return `"${value}"`; // CSV safe
  //         })
  //         .join(",")
  //     ),
  //   ];

  //   const csvContent = csvRows.join("\n");
  //   const blob = new Blob([csvContent], { type: "text/csv" });
  //   const url = URL.createObjectURL(blob);

  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "filtered_items_export.csv";
  //   a.click();

  //   URL.revokeObjectURL(url);
  // };

  const exportFile = () => {
    if (!displayItemlist || !displayItemlist.length) {
      return alert("No data to export.");
    }

    // export fields and labels
    const fieldsToExport = [
      { key: "itemName", label: "Item Name" },
      { key: "itemCategory", label: "Item Class" },
      { key: "unitPrice", label: "Unit Price" },
      { key: "costPrice", label: "Unit Cost" },
      { key: "quantity", label: "Stock on Hand" },
      { key: "wareHouseName", label: "Warehouse" },
    ];

    // Rows
    const data = displayItemlist.map((row) => {
      const newRow = {};
      fieldsToExport.forEach((field) => {
        newRow[field.label] = row[field.key] ?? "";
      });
      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);

    // column widths (based on max string length in each column)
    const colWidths = fieldsToExport.map((field) => {
      const maxLength = Math.max(
        field.label.length,
        ...data.map((row) => row[field.label]?.toString().length || 0)
      );
      return { wch: maxLength + 5 }; // +5 for spacing
    });
    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Items");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, "items_export.xlsx");
  };
  return (
    <Switch>
      <Route exact path={path}>
        <ToolBar
          title="All Items"
          showtools
          onCreate={gotoAddItem}
          createButtonText="Create Item"
          valueName="itemName"
          dataList={itemList}
          setSearchItem={setSearchItem}
          exportFile={exportFile}
          handleImportFile={handleImportFile}
          handleTriggerImport={handleTriggerImport}
        />
        <StyledCard mt={2}>
          <TableWithPagination
            rowsPerPage={rowsPerPage}
            page={page}
            total={paginationProps.totalItems}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            columns={columns}
            dataSource={displayItemlist}
            /*  onRow={handleTableRow} */
          />
        </StyledCard>
        <DeleteModal
          open={deleteModalProps.visible}
          loading={deleteModalProps.loading}
          itemName={deleteModalProps.name}
          onClose={() =>
            setDeleteModalProps((prevState) => ({
              ...prevState,
              visible: false,
            }))
          }
          onDelete={handleItemDelete}
          title="Delete Warehouse"
        />

        <Feedback
          open={feedbackProps.open}
          message={feedbackProps.message}
          type={feedbackProps.type}
          onClose={() =>
            setFeedbackProps((prevState) => ({ ...prevState, open: false }))
          }
        />
      </Route>
      <Route path={`${path}/add-item`}>
        <AddItem />
      </Route>
      <Route exact path={`${path}/:id`}>
        <ItemDetails />
      </Route>
      <Route path={`${path}/:id/edit`}>
        <EditItem />
      </Route>
    </Switch>
  );
};
